export const formatExternalUrl = (url?: string) =>
  url ? (url.startsWith('http') ? url : `//${url}`) : undefined;
